<nav class="nav nav-secondary mixed-loyalty-nav my-0">
  <a class="nav-item" [routerLink]="['/payment']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
    <label>{{ 'nav.payment.cards' | translate }}</label>
  </a>
  <a class="nav-item" [routerLink]="['/ecashhistory']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
    <label>{{ 'nav.ecash.history' | translate }}</label>
  </a>
</nav>
